export enum AuthType {
  EMAIL = "EMAIL",
  WALLET = "WALLET",
  API_KEY = "API_KEY",
}
